import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import { BlobServiceClient } from '@azure/storage-blob';
import { azureConfig } from 'helpers/azureConfig';
import 'react-toastify/dist/ReactToastify.css';
import { Container, Row, Col } from 'reactstrap';
import { getTempById as onGetTempById } from "../../store/templates/actions";
import { API_URL } from 'helpers/app_url';
const UnEditorOld = forwardRef(({ design }, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageList, setImageList] = useState([]);
  const [selectImageCallback, setSelectImageCallback] = useState(null);
  const editorRef = useRef(null);
  const { projectId, templateId } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { datatemp, loading } = useSelector(state => ({
    datatemp: state.Template.datatemp,
    loading: state.Template.loading,
  }));

  useEffect(() => {
    
    dispatch(onGetTempById(templateId));
  }, [dispatch, templateId]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://editor.unlayer.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.unlayer.init({
        id: 'editor',
        projectId: 228097,
        displayMode: 'email',
        user: {
          id: 1
        },
        features: {
          stockImages: {
            enabled: false,
          },
          textEditor: {
            tables: true
          },
          sendTestEmail: true
        }
      });

      window.unlayer.registerProvider('userUploads', function (params, done) {
        const page = 1;
        const perPage = 50;
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj.resultData.bearerToken;
        const str = 'Bearer ' + token;
        fetch(`${API_URL}ProjectGallery/allproject/?projectId=${projectId}&page=${page}&perPage=${perPage}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': str
          }
        })
          .then(response => response.json())
          .then(data => {
            const images = data.map((image, i) => ({
              id: image.id,
              location: image.projectGalleryLink, 
              width: 200,
              height: 200, 
              contentType: 'image/png',
              source: 'user'
            }));

            const total = data.total;
            const hasMore = total > page * perPage;

            done(images, { hasMore, page, perPage, total });
          })
          .catch(error => {
            console.error('Error fetching images:', error);
            done([], { hasMore: false, page, perPage, total: 0 });
          });
      });

      window.unlayer.registerCallback('image', async (file, done) => {
        const attachment = file.attachments[0];
        const sasToken = azureConfig.sasToken;
        const containerName = azureConfig.containerName;
        const storageAccountName = azureConfig.storageAccountName;
        const fileName = `${Date.now()}_${attachment.name}`;
        try {
          const blobServiceClient = new BlobServiceClient(
            `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
          );
          const containerClient = blobServiceClient.getContainerClient(containerName);
          const blobClient = containerClient.getBlockBlobClient(fileName);
          
          await blobClient.uploadBrowserData(attachment);
          const fullPath = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
          done({ progress: 100, url: fullPath });
        } catch (error) {
          console.error('Error uploading file to Azure Blob Storage:', error);
        }
      });
      
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [templateId]);

  useEffect(() => {
    if (datatemp && datatemp.templateContent) {
      const templateContent = datatemp.templateContent;
      const templateCss = datatemp.templateCSS;
      if (templateContent) {
        try {
        
          const parsedContent = JSON.parse(templateContent);
          window.unlayer.loadDesign(parsedContent);
        } catch (error) {
          console.error('Error parsing template content:', error);
        }
      }
    }
  }, [datatemp]);

 
  const handleImageSelect = (src) => {
    if (selectImageCallback) {
      selectImageCallback({ url: src });
      setIsModalOpen(false);
    }
  };

  const exportHtml = (callback) => {
    if (window.unlayer) {
      window.unlayer.exportHtml((data) => {
        if (callback) {
          callback(data);
        }
      });
    }
  };
  useImperativeHandle(ref, () => ({
    exportHtml: (callback) => {
      if (window.unlayer) {
        window.unlayer.exportHtml((data) => {
          if (callback) {
            callback(data);
          }
        });
      }
    }
  }));
  const saveDesign = () => {
    try {
      if (window.unlayer && editorRef.current) {
        const designState = window.unlayer.saveDesign();
        return designState;
      }
      return null;
    } catch (error) {
      console.error('Error saving design:', error);
      return null;
    }
  };

  return (
    <div>
      <div id="editor" emailTemplateTitle={datatemp?.projectTemplatePreContent?.templateTitle} datatemp={datatemp} style={{ height: '800px' }} />
      
    </div>
  );
});

UnEditorOld.displayName = 'LoadUnlayerNew';

UnEditorOld.propTypes = {
  design: PropTypes.shape({
    html: PropTypes.string.isRequired
  }),
};

export default UnEditorOld;



